import {
  AdjustmentSourceType,
  AdjustmentType,
  Adjustment,
} from '../types/generated/graphql-types'

export const LOCK_EXTENSION_ADJUSTMENT_TITLE = 'Lock extension'

/** Encompass `adjustmentType` for lock extension rows on a rate lock request. */
export const LOCK_EXTENSION_ADJUSTMENT_TYPE = 'LockExtensionAdjustment'

/**
 * Encompass stores lock extension price adjustments as negative values (including
 * global config `priceAdjustmentPerDay` and lock-request adjustment rows).
 * Sage pricing and borrower-facing display use the opposite sign for margin/points math.
 */
export function encompassLockExtensionValueForSagePricing(
  encompassSignedValue: number
): number {
  if (!encompassSignedValue) {
    return 0
  }

  return parseFloat((-encompassSignedValue).toFixed(3))
}

export function sumLockExtensionAdjustmentMarginPoints(
  adjustments:
    | Array<{
        adjustmentType?: string | null
        adjustment?: number | null
      }>
    | null
    | undefined
): number {
  if (!adjustments?.length) {
    return 0
  }

  let sum = 0
  for (const row of adjustments) {
    if (row?.adjustmentType !== LOCK_EXTENSION_ADJUSTMENT_TYPE) {
      continue
    }
    sum += row.adjustment ?? 0
  }

  return parseFloat(sum.toFixed(3))
}

export function buildLockExtensionMarginAdjustmentObject(
  marginPoints: number
): Adjustment | null {
  if (!marginPoints) {
    return null
  }

  return {
    title: LOCK_EXTENSION_ADJUSTMENT_TITLE,
    amount: marginPoints,
    isHidden: false,
    isStop: false,
    isCompAdjustment: true,
    filter: null,
    adjustmentSourceType: AdjustmentSourceType.BusinessRule,
    adjustmentType: AdjustmentType.Margin,
  }
}
